<template>
  <div v-if="show_card">
    <div class="upgrade-alert rounded-5 brand_accent_light_bg">
      <div class="d-flex justify-content-start align-items-center">
        <!-- ALERT MESSAGE -->
        <div
          class="alert-msg color_text d-flex justify-content-start align-items-center nowrap"
        >
          <div class="mr-2">
            <img v-lazy="localImg('GiftBox.png')" alt="G.Box" />
          </div>

          <template v-if="getSummerStatus === 'active'"
            >No Summer school subscription, click
            <router-link
              :to="{
                name:
                  account_type === 'parent'
                    ? 'ParentSummerSchoolPlan'
                    : 'StudentSummerSchoolPlan',
              }"
              class="btn-link"
            >
              <span class="ml-1"></span>here<span class="mr-1"></span>
            </router-link>
            to subscribe
          </template>

          <template v-else>
            <div v-if="account_type === 'school' || account_type === 'teacher'">
              <template v-if="!is_subscribed">
                You do not have an active subscription
              </template>
              <template v-if="is_subscribed && plan === 'trial'">
                You have {{ days_left }} days of free trial left!
              </template>
              <template
                v-if="is_subscribed && plan !== 'trial' && days_left < 7"
              >
                You have {{ days_left }} days of your {{ plan }} plan left!
              </template>
            </div>

            <div v-else>
              <template v-if="!is_subscribed && page_type !== 'catchup'">
                Contact school administrator for access
              </template>

              <template v-if="!is_catchup && page_type === 'catchup'">
                You do not have active subscription to access catchup
              </template>

              <template v-if="is_subscribed && plan === 'trial'">
                You have {{ days_left }} days of free trial left!
              </template>
              <template
                v-if="is_subscribed && plan !== 'trial' && days_left < 7"
              >
                You have {{ days_left }} days of your {{ plan }} plan left!
              </template>
            </div>
          </template>
        </div>

        <template v-if="page_type === 'catchup'">
          <!-- ALERT CTA -->
          <div
            class="alert-cta"
            v-if="account_type === 'parent' || account_type === 'student'"
          >
            <router-link
              :to="{
                name:
                  account_type === 'student'
                    ? 'StudentUpgradePlan'
                    : 'ParentUpgradePlan',
                query: { type: 'catchup' },
              }"
              class="btn btn-whitish"
              >Upgrade</router-link
            >
          </div>
        </template>
      </div>
      <!-- CLOSE ALERT -->
      <div class="avatar pointer" @click="close">
        <span
          class="icon-decline flex-center border_grey_dark font-weight-600 font-18"
        ></span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "UpgradeAlertCard",

  data() {
    return {
      account_type: this.$route.path.split("/")[1],
      page_type: this.$route.path.split("/")[2],
      days_left: 0,
      plan: "",
      is_subscribed: false,
      is_catchup: false,
      show_card: false,
      school_sub: 0,
      school_active: 1,
    };
  },

  computed: {
    ...mapGetters(["getSelectedChildID", "getCurrentClass", "getSummerStatus"]),
  },

  watch: {
    $route: {
      handler(newVal) {
        if (newVal) this.checkSubscriptionStatus();
      },
    },
  },

  mounted() {
    this.checkSubscriptionStatus();
  },

  methods: {
    ...mapActions(["getSubscriptionPaymentStatus"]),

    checkSubscriptionStatus() {
      console.log("sub status", this.account_type);
      if (this.account_type === "parent")
        if (this.getSelectedChildID === this.$route.params.id)
          this.callPaymentStatus(this.getSelectedChildID);
        else this.callPaymentStatus(this.$route.params.id);
      else if (this.account_type === "teacher")
        this.callPaymentStatus(0, this.getCurrentClass);
      else this.callPaymentStatus();
    },

    callPaymentStatus(child_id = 0, class_id = 0) {
      this.getSubscriptionPaymentStatus({ child_id, class_id })
        .then((response) => {
          // CHECK BACK TO SCHOOL STATUS
          // this.checkBackToSchoolStatus(response.data.expiry);

          this.days_left = response.data.days_left;
          this.plan = response.data.plan;
          this.school_sub = response.data.is_school_sub;

          this.school_active =
            this.account_type === "parent" || this.account_type === "student"
              ? response.data.school_active
              : 1;

          this.is_subscribed =
            this.account_type === "parent" || this.account_type === "student"
              ? response.data.lms
              : response.data.status;

          this.is_catchup =
            this.account_type === "parent" || this.account_type === "student"
              ? response.data.status
              : false;

          // FOR PARENT AND STUDENT CATCHUP
          this.$emit("checkStatus", this.is_catchup);

          if (this.school_active && this.page_type !== "catchup") {
            if (
              this.plan === "trial" &&
              !response.data.is_school_sub &&
              this.account_type === "teacher"
            )
              this.show_card = false;
            else if (
              this.plan === "trial" &&
              response.data.school_active &&
              this.account_type === "student"
            )
              this.show_card = false;
            else if (
              this.is_subscribed === false ||
              this.plan === "trial" ||
              (this.is_subscribed && this.days_left < 7) ||
              (this.is_subscribed === false && this.school_sub === 0)
            )
              this.show_card = true;
            else this.show_card = false;
          } else if (!this.school_active && this.page_type === "catchup") {
            if (this.is_catchup === false) this.show_card = true;
            else this.show_card = false;
          } else if (this.school_active && this.page_type === "catchup") {
            if (this.is_catchup === false) this.show_card = true;
            else this.show_card = false;
          } else this.show_card = false;
        })
        .catch((err) => console.log(err));
    },

    checkBackToSchoolStatus(expiry) {
      let currentDate = new Date();
      let expiry_date = new Date(expiry);
      const diffTime = expiry_date - currentDate;
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      console.log("sub expiry difference", diffDays);
      this.$emit("backToSchoolStatus", false);
    },

    close() {
      localStorage.show_subscripition_alert = false;
      this.$emit("closeUpgradeAlert");
    },
  },
};
</script>

<style lang="scss" scoped>
.upgrade-alert {
  @include flex_row_between_nowrap;
  align-items: center;
  padding: 8px 15px;
  margin-bottom: 12px;

  @include breakpoint_max(sm) {
    padding: 9px 10px;
  }

  .alert-msg {
    font-size: 14px;
    line-height: 19px;

    img {
      @include equal_min_edge(27);
      margin-right: 10px;

      @include breakpoint_max(sm) {
        @include equal_min_edge(25);
        margin-right: 7px;
      }

      @include breakpoint_max(xs) {
        @include equal_min_edge(23);
      }
    }

    @include breakpoint_max(sm) {
      font-size: 12.5px;
    }
    @include breakpoint_max(xs) {
      font-size: 12px;
    }
  }

  .alert-cta {
    margin-left: 10px;

    .btn {
      font-size: 10.5px !important;

      @include breakpoint_max(sm) {
        font-size: 10px !important;
      }
    }
  }

  .avatar {
    transition: all 0.3s ease-in-out;

    span {
      transition: all 0.3s ease-in-out;
    }

    &:hover {
      background: $brand_inverse_light;

      span {
        color: $border_grey_dark !important;
      }
    }

    .icon-decline {
      @include breakpoint_max(sm) {
        font-size: 16px !important;
        font-weight: 500 !important;
      }
    }
  }
}
</style>
